module.exports = __webpack_public_path__ + "img/blog-4.8c780825.webp";